export const planets = [
  {
    name: "Mercury",
    type: "Terrestrial planet",
    distance: "57.9 million km from the Sun",
    moons: 0,
    diameter: "4,879 km",
    day: "59 Earth days",
    year: "88 Earth days",
    description:
      "The smallest planet in the Solar System and the closest to the Sun. Mercury has a cratered, airless surface that swings between extreme temperatures.",
    fact: "A single day on Mercury (sunrise to sunrise) lasts about 176 Earth days — longer than its year.",
    gradient: "radial-gradient(circle at 30% 30%, #c9b59a, #6f5b48 60%, #2c2620 100%)",
    glow: "rgba(220,180,140,0.35)",
  },
  {
    name: "Venus",
    type: "Terrestrial planet",
    distance: "108.2 million km from the Sun",
    moons: 0,
    diameter: "12,104 km",
    day: "243 Earth days",
    year: "225 Earth days",
    description:
      "Often called Earth's twin in size, Venus is the hottest planet in the Solar System due to a runaway greenhouse atmosphere of carbon dioxide.",
    fact: "Venus rotates in the opposite direction to most planets — the Sun rises in the west and sets in the east.",
    gradient: "radial-gradient(circle at 30% 30%, #f4d9a1, #c98a3e 60%, #6a3a16 100%)",
    glow: "rgba(244,180,90,0.40)",
  },
  {
    name: "Earth",
    type: "Terrestrial planet",
    distance: "149.6 million km from the Sun",
    moons: 1,
    diameter: "12,742 km",
    day: "24 hours",
    year: "365.25 days",
    description:
      "The only known world with liquid surface water and life. Earth's atmosphere, magnetic field, and oceans together create a uniquely habitable environment.",
    fact: "Earth is the only planet not named after a Greek or Roman god.",
    gradient: "radial-gradient(circle at 30% 30%, #6fb8ff, #1d62b6 55%, #082147 100%)",
    glow: "rgba(80,160,255,0.45)",
  },
  {
    name: "Mars",
    type: "Terrestrial planet",
    distance: "227.9 million km from the Sun",
    moons: 2,
    diameter: "6,779 km",
    day: "24 hr 37 min",
    year: "687 Earth days",
    description:
      "A cold, desert world with the largest volcano and the deepest canyon in the Solar System. Mars is a primary target for the search for past microbial life.",
    fact: "Olympus Mons on Mars is about 22 km tall — nearly three times the height of Mount Everest.",
    gradient: "radial-gradient(circle at 30% 30%, #ff9874, #c0432a 55%, #4a1409 100%)",
    glow: "rgba(255,110,80,0.40)",
  },
  {
    name: "Jupiter",
    type: "Gas giant",
    distance: "778.5 million km from the Sun",
    moons: 95,
    diameter: "139,820 km",
    day: "9 hr 56 min",
    year: "11.9 Earth years",
    description:
      "The largest planet in the Solar System. Jupiter is a stormy gas giant whose Great Red Spot is a cyclone that has lasted for centuries.",
    fact: "Jupiter's mass is more than twice that of all the other planets in the Solar System combined.",
    gradient: "radial-gradient(circle at 30% 30%, #f1c8a0, #b07b4a 50%, #4a2818 100%)",
    glow: "rgba(220,180,120,0.40)",
  },
  {
    name: "Saturn",
    type: "Gas giant",
    distance: "1.43 billion km from the Sun",
    moons: 146,
    diameter: "116,460 km",
    day: "10 hr 42 min",
    year: "29.5 Earth years",
    description:
      "Famous for its bright, complex ring system made primarily of ice and rock. Saturn is the least dense planet — it would float in water if a big enough ocean existed.",
    fact: "Saturn's rings span roughly 282,000 km wide but are only about 10 meters thick on average.",
    gradient: "radial-gradient(circle at 30% 30%, #f5e0b3, #b89762 55%, #4a3818 100%)",
    glow: "rgba(240,210,140,0.40)",
  },
  {
    name: "Uranus",
    type: "Ice giant",
    distance: "2.87 billion km from the Sun",
    moons: 27,
    diameter: "50,724 km",
    day: "17 hr 14 min",
    year: "84 Earth years",
    description:
      "An ice giant tilted on its side, Uranus rotates almost perpendicular to its orbit. Its pale blue color comes from methane in its upper atmosphere.",
    fact: "Uranus's extreme axial tilt means each pole spends about 42 Earth years in continuous daylight, then 42 in darkness.",
    gradient: "radial-gradient(circle at 30% 30%, #b8f0ef, #4ea7b7 55%, #0d3a47 100%)",
    glow: "rgba(140,220,230,0.40)",
  },
  {
    name: "Neptune",
    type: "Ice giant",
    distance: "4.50 billion km from the Sun",
    moons: 14,
    diameter: "49,244 km",
    day: "16 hr 6 min",
    year: "165 Earth years",
    description:
      "The most distant major planet from the Sun. Neptune's deep blue atmosphere hosts the fastest winds in the Solar System.",
    fact: "Winds on Neptune can reach 2,100 km/h — faster than the speed of sound on Earth.",
    gradient: "radial-gradient(circle at 30% 30%, #6fa8ff, #1b4ec2 55%, #06183f 100%)",
    glow: "rgba(90,140,255,0.45)",
  },
];
